import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    obj: {
      a: 1,
      b: {
        c: "Hello World",
        d: 2,
        e: {
          f: {
            g: -4,
          },
        },
        h: "Good Night Moon",
        i: {},
      },
    },
    cb: (elm) => typeof elm === "string",
  },
  {
    obj: {
      a: 1,
      b: {
        c: "Hello World",
        d: 2,
        e: {
          f: {
            g: -4,
          },
        },
        h: "Good Night Moon",
        i: {},
      },
    },
    cb: (elm) => typeof elm === "number",
  },
  {
    obj: {
      a: 1,
      b: {
        c: "Hello World",
        d: 2,
        e: {
          f: {
            g: -4,
          },
        },
        h: "Good Night Moon",
        i: {},
      },
    },
    cb: (elm) => typeof elm === "number" && elm > 0,
  },
  {
    obj: {
      a: 1,
      b: {
        c: "Hello World",
        d: 2,
        e: {
          f: {
            g: -4,
          },
        },
        h: "Good Night Moon",
        i: {},
      },
    },
    cb: (elm) => typeof elm === "string" && elm.length < 10,
  },
  {
    obj: {
      a: 1,
      b: {
        c: "Hello World",
        d: 2,
        e: {
          f: {
            g: -4,
          },
        },
        h: "Good Night Moon",
        i: {},
      },
    },
    cb: (elm) => typeof elm / 2 === 0,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { obj, cb } = test;
      let outcome1 = output()(obj, cb);
      let outcome2 = Solution(obj, cb);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
